import { Auth } from 'aws-amplify';

const getSession = () => Auth && Auth.currentSession();

export const getIdToken = async () => {
  const session = await getSession();

  return session && session.getIdToken();
};

export const getToken = async () => {
  const idToken = await getIdToken();

  if (idToken) {
    return idToken.getJwtToken();
  } else {
    return undefined;
  }
};
